import React from "react";
import withStyles from "@mui/styles/withStyles";
import { ClickAwayListener, Popper } from "@mui/material";

const styles = theme => {
  return {
    popper: {
      zIndex: theme.zIndex.modal,
    },
  };
};

// MUI popper that closes on mousedown away
function Dropdown(Toggle, Contents) {
  const DropdownUnstyled = class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        anchorEl: null,
        open: false,
      };

      this.toggleRef = React.createRef();
      this.handleClose = this.handleClose.bind(this);
      this.handleClick = this.handleClick.bind(this);
    }

    handleClose = event => {
      if (this.toggleRef.current && this.toggleRef.current.contains(event.target)) {
        return;
      }

      this.setState({
        open: false,
      });
    };

    handleClick(event) {
      const { currentTarget } = event;
      this.setState(state => ({
        anchorEl: currentTarget,
        open: !state.open,
      }));
    }

    render() {
      const { classes, ...nonClassProps } = this.props;
      return (
        <div>
          <div ref={this.toggleRef} onClick={this.handleClick}>
            <Toggle {...nonClassProps} />
          </div>
          <ClickAwayListener onClickAway={this.handleClose}>
            <Popper
              className={classes.popper}
              open={this.state.open}
              anchorEl={this.toggleRef.current}
            >
              <Contents {...nonClassProps} />
            </Popper>
          </ClickAwayListener>
        </div>
      );
    }
  };

  return withStyles(styles, { withTheme: true })(DropdownUnstyled);
}

export default Dropdown;
